export default __webpack_public_path__ + "static/media/FlexeetLogo.eb8c9b2f.svg";